"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = (config, instance) => ({
  getItems(params, nextToken) {
    return instance.get('/v2/notifications', {
      params: {
        pageSize: 50,
        sortField: 'createdAt',
        sortDir: 'desc',
        ...params,
        pageToken: nextToken
      },
      baseURL: config.apiPrefixes.notificationsHTTP
    });
  },
  readOne(id) {
    return instance.put(`/notifications/${id}`, null, {
      baseURL: config.apiPrefixes.notificationsHTTP
    });
  }
});
exports.default = _default;